import { createReducer, on } from '@ngrx/store';
import { systemLoadingAction } from './system.actions';
import { SystemState } from '@store/system/system-state.model';

export const initialState: SystemState = {
    loadingCount: 0,
};

export const systemReducer = createReducer(
    initialState,
    on(
        systemLoadingAction,
        (state: SystemState, { loading }): SystemState => ({
            ...state,
            loadingCount: loading ? state.loadingCount + 1 : Math.max(0, state.loadingCount - 1),
        }),
    ),
);
